import {api} from '~/common/fabric/EventGuests/api/api';

export const contactsApi = api.injectEndpoints({
  endpoints: (builder) => ({
    fetchContacts: builder.query({
      async queryFn({eventId, searchParams, returnAll}, _queryApi, _extraOptions, baseQuery) {
        const params = new URLSearchParams(searchParams);

        if (returnAll) {
          params.set('page', '1');
          params.set('per_page', Number.MAX_SAFE_INTEGER);
        }

        const url = `/ajax/event/${eventId}/guestlist/contacts?${params.toString()}`;

        const contactsResponse = await baseQuery({url});

        if (contactsResponse.error) {
          return {error: contactsResponse.error};
        }

        const {
          contacts,
          letters,
          all_are_guests: allAreGuests,
          contact_groups: contactGroups,
        } = contactsResponse.data;

        if (returnAll) {
          return {data: {contacts}};
        }

        return {data: {contacts, letters, allAreGuests, contactGroups}};
      },
      providesTags: () => [{type: 'Contacts', id: 'LIST'}],
    }),

    saveNewContact: builder.mutation({
      query: (contact) => ({
        url: '/ajax/profile/contacts',
        method: 'PUT',
        body: JSON.stringify(contact),
      }),
      invalidatesTags: [{type: 'Contacts', id: 'LIST'}],
    }),
  }),
});

export const {useFetchContactsQuery, useLazyFetchContactsQuery, useSaveNewContactMutation} =
  contactsApi;
